import { NotFound } from './theme/NotFound';
import { useParams } from 'react-router-dom';
import { BudgetReport } from './budget/BudgetReport';
import { BudgetReportContract } from './budget/BudgetReportContract';
import { BudgetLineReport } from './budget/BudgetLineReport';
import { BudgetReportCDP } from './budget/BudgetReportCDP';
import { BudgetReportExecution } from './budget/BudgetReportExecution';
import { IncomeReport } from './budget/IncomeReport';
import { BudgetEgressReport } from './budget/BudgetEgressReport';
import { BudgetRPReport } from './budget/BudgetRPReport';
import { BudgetReportDocument } from './budget/BudgetReportDocument';
import { BudgetReportByRP } from './budget/BudgetReportByRP';


export const RouterBudget = (props: any) => {

    const { module, view }: any = useParams();

    const renderSwitch = (url: string) => {

        switch (url) {
            case 'report-budget':
                return <BudgetReport />;
            case 'report-budget-document':
                return <BudgetReportDocument/>;
            case 'report-budget-contract':
                return <BudgetReportContract />;
            case 'report-budget-lines':
                return <BudgetLineReport />;
            case 'report-budget-cdp':
                return <BudgetReportCDP />;
            case 'report-budget-rp':
                return <BudgetRPReport />;
            case 'report-budget-execution':
                return <BudgetReportExecution />;
            case 'report-budget-income':
                return <IncomeReport />;
            case 'reporte-egreso':
                return <BudgetEgressReport />;
            case 'reporte-detalle-registro-presupuestal':
                return <BudgetReportByRP />;
            default:
                return <NotFound />;
        }
    }

    return (
        <div className=''>
            {renderSwitch(view)}
        </div>
    );
}